import { DocumentNode, gql } from '@apollo/client'

export const GET_API_CLIENTS_LIST: DocumentNode = gql`
    query ListApiClients {
        listApiClients {
            id
            clientId
            name
            active
            created
            updated
            lastUsed
            rateLimitPerMinute
            tokenExpiryMinutes
            tokenCount
            daycares {
                id
                name
                city
                phone
                email
                type
                canWrite
            }
        }
    }
`

export const GET_API_CLIENT: DocumentNode = gql`
    query GetApiClient($id: Int!) {
        getApiClient(id: $id) {
            id
            clientId
            name
            active
            created
            updated
            lastUsed
            rateLimitPerMinute
            tokenExpiryMinutes
            tokenCount
            daycares {
                id
                name
                city
                phone
                email
                type
                canWrite
            }
        }
    }
`
